import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml',
  standalone: false
})
export class StripHtmlPipe implements PipeTransform {
  private parser: DOMParser;

  constructor() {
    this.parser = new DOMParser();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: any, ...args: any[]): string {
    const el = this.parser.parseFromString(value, 'text/html');
    return el ? el.body.textContent : value;
  }
}
